const getTxHashContext = (theapp) => {
	let tx_hash;
	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
		return tx_hash;

	try {
		// parse caller url to see if a tx is in the parameters
		const URL = require("url");
		
		if (start_conditions.tx_hash)
			tx_hash = start_conditions.tx_hash;
		else if (start_conditions.caller)
			tx_hash = URL.parse(start_conditions.caller, true).query.tx;
		else {
			let client_window_url = theapp.getWidgetClientWindowUrl();

			if (client_window_url)
			tx_hash = URL.parse(client_window_url, true).query.tx;
		}

	}
	catch(e) {
		console.log('exception in getTxHashContext: ' + e);
	}


	return tx_hash;

}

export default getTxHashContext;